import isSenderImageEnabled from 'mini-mail-list-view/lib/utils/mailList/isSenderImageEnabled';
import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';

/**
 * This action will get dispatched when "Sender Image" option is loaded
 */
const loadSenderImageOption = action('loadSenderImageOption', () =>
    addDatapointConfig({
        name: 'LoadSenderImageOption',
        customData: { SenderImage: isSenderImageEnabled() ? 1 : 0 },
    })
);

export default loadSenderImageOption;
